import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { Field, ReadOnly, Section } from "./ItemFormParts";

const CURRENCIES = ["IQD", "USD", "SAR", "AED"];

// 💰 الرقابة السعرية: السعر المرجعي · نسبة التسامح (±15%) · العملة.
export const ItemSectionPrice = ({ form, setForm, branchCurrency, branchName }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <Section testid="item-section-price" tinted cols={3} title={`💰 ${t("purchases.items.priceControl")}`}
             hint={t("purchases.items.priceControlHint")}>
      <Field label={t("purchases.items.refPrice")}>
        <NeuInput data-testid="item-reference_price" dir="ltr" value={form.reference_price ?? ""}
                  onChange={set("reference_price")} placeholder={t("purchases.items.refPricePlaceholder")} />
      </Field>
      <Field label={t("purchases.items.tolerance")} hint={t("purchases.items.toleranceDefault")}>
        <NeuInput data-testid="item-tolerance_percent" dir="ltr" value={form.tolerance_percent ?? ""}
                  onChange={set("tolerance_percent")} />
      </Field>
      <Field label={t("purchases.items.currency")}
             hint={branchCurrency ? t("purchases.items.currencyFromBranch", { branch: branchName }) : null}>
        {branchCurrency ? (
          <ReadOnly testid="item-currency" value={branchCurrency} />
        ) : (
          <NeuDropdown testid="item-currency" value={form.currency} onChange={(value) => setForm({ ...form, currency: value })}
                       options={CURRENCIES.map((c) => ({ value: c, label: c }))} />
        )}
      </Field>
    </Section>
  );
};
